/**
 * Whose objectives the pillars are counted among, on the objectives page and on a pillar's page:
 * the whole organization, the reader's direct team, or the people and objectives the list's filters
 * keep.
 */
export const PillarScope = {
    ORGANIZATION: 'organization',
    TEAM: 'team',
    FILTERS: 'filters',
} as const;

export type PillarScopeType = (typeof PillarScope)[keyof typeof PillarScope];

/** The address parameter that names the scope asked for. */
export const PILLAR_SCOPE_PARAM = 'pillarScope';
